@if (enabled) {
    <div class="header-ctrl-wrapper">
        <div class="header-ctrl d-flex justify-content-between align-items-center">
            <div class="header-ctrl-l" [ngClass]="leftContentClass">
                @if (showBack !== false) {
                    <span class="ui-icon ui-icon-size-lg ui-back d-flex align-items-center" (click)="onBackClick()">
                        <vn-icon name="theme-left" />
                        @if (backButtonText) {
                            <span class="txt-xs text-nowrap ml-2 back-button-text m-0">{{ backButtonText }}</span>
                        }
                    </span>
                }
                <ng-content select="[left]" />
                @if (useLogoHeader) {
                    <ng-content select="[header-bar-logo-slot]" />
                }
            </div>
            @if (!useLogoHeader && title) {
                <div [ngClass]="titleCssClass" class="header-ctrl-txt">{{ title }}</div>
            }

            <div class="header-ctrl-r" [ngClass]="{ 'header-ctrl-r__btn': closeButtonText }">
                @if (!closeButtonText) {
                    @if (showClose !== false) {
                        <vn-icon name="theme-ex" class="vn-icon-ui-close" (click)="onCloseClick()" />
                    }
                } @else {
                    @if (showClose !== false) {
                        @if (useDSButton && closeDSButtonStyle !== undefined) {
                            <button
                                dsTouchClick
                                ds-button
                                [variant]="closeDSButtonStyle.variant ?? 'outline'"
                                [kind]="closeDSButtonStyle.kind ?? 'secondary'"
                                [size]="closeDSButtonStyle.size ?? 'medium'"
                                [inverse]="closeDSButtonStyle.inverse ?? false"
                                (click)="onCloseClick()">
                                {{ closeButtonText }}
                            </button>
                        } @else {
                            <span class="close-text btn btn-md" [ngClass]="closeButtonTextCssClass" (click)="onCloseClick()">{{
                                closeButtonText
                            }}</span>
                        }
                    }
                }
            </div>
        </div>
    </div>
}
